var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-editor"},[_c('div',{attrs:{"id":_vm.id}},[_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }